import { Route } from 'react-router';
import * as Sentry from '@sentry/react';
export const SentryRoute = Sentry.withSentryReactRouterV7Routing(Route);
